import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GovernyInfo } from "../../../../lib/types";
import { ARMY_UNITS } from "../../../../lib/enums";
import { formatNumber, getData } from "../../../../lib/commonFunctions";
import SubMenu from "../../../Menu/SubMenu";
import { DragescentState } from "../../../../store/reducers/stateType";
import GovernoratePivotColumn from "../../../Common/GovernoratePivotColumn";

type OverviewRowData = {
  land: number;
  turn: number;
  maxTurns: number;
  turnBank: number;
  [ARMY_UNITS.E1]: number;
  [ARMY_UNITS.E2]: number;
  [ARMY_UNITS.E3]: number;
  [ARMY_UNITS.SIEGE_ENGINE]: number;
  armyAttack: number;
  armyDefence: number;
  wallAttack: number;
  wallDefence: number;
  magicAttack: number;
  magicDefence: number;
  thievesAttack: number;
  thievesDefence: number;
}

const AllianceOverview = () => {
  const members = useSelector((state: DragescentState) => state.governorate.alliance.members);

  const [data, setData] = useState<{[keys: string]: OverviewRowData} | null>(null);

  const isTurnBank = data && Object.values(data).some(row => row.turnBank);

  useEffect(() => {
    getData(`/api/overview/alliance`)
      .then(overviewData => setData(overviewData));
  }, []);

  return (
    <>
      <SubMenu
        tabs={[
          {
            name: "AllianceOverview",
            title: "Overview",
            icon: "imperator",
            label: "Alliance",
            active: true,
            parameters: {
              reload: false
            }
          },
          {
            name: "GeneralsOverview",
            title: "Overview",
            icon: "imperator",
            label: "Generals",
            active: false,
            parameters: {
              reload: true
            }
          },
          {
            name: "DevelopmentOverview",
            title: "Overview",
            icon: "imperator",
            label: "Development",
            active: false,
            parameters: {
              reload: true
            }
          },
          {
            name: "OverviewPalace",
            title: "Overview",
            icon: "imperator",
            label: "Overview Palace",
            active: false,
            parameters: {
              reload: true
            }
          }
        ]}
      />

      <div className="box imp-overview" style={{ overflowX: "scroll" }}>
        {data && <table className={"table text-center table-hover"}>
          <thead>
          <tr>
            <th rowSpan={2} style={{ textAlign: "left" }}>Governorate</th>
            <th rowSpan={2}>Land</th>
            <th rowSpan={isTurnBank ? 1 : 2}>Turn</th>
            <th colSpan={4}>Units</th>
            <th><i className="icon icon-xs icon-utok"/></th>
            <th><i className="icon icon-xs icon-wall-attack"/></th>
            <th><i className="icon icon-xs icon-magie"/></th>
            <th><i className="icon icon-xs icon-zlodeji"/></th>
          </tr>
          <tr>
            {isTurnBank && <th>Turn Bank</th>}
            <th>Tier 1</th>
            <th>Tier 2</th>
            <th>Tier 3</th>
            <th>Engines</th>
            <th><i className="icon icon-xs icon-obrana"/></th>
            <th><i className="icon icon-xs icon-obrana"/></th>
            <th><i className="icon icon-xs icon-obrana"/></th>
            <th><i className="icon icon-xs icon-zlodej-obrana"/></th>
          </tr>
          </thead>
          <tbody>
          {members.map((member: GovernyInfo) => (
            <>
              <tr>
                <GovernoratePivotColumn
                  id={member.id}
                  name={member.name}
                  race={member.race.name}
                  commander={member.commander}
                  emperor={member.emperor}
                />
                <td>{formatNumber(data[member.id].land)}</td>
                <td>
                  {data[member.id].turn}/{data[member.id].maxTurns}
                  {isTurnBank && <><br />{data[member.id].turnBank && `${50 - data[member.id].turnBank}/50`}</>}
                </td>
                <td>{data[member.id][ARMY_UNITS.E1]}</td>
                <td>{data[member.id][ARMY_UNITS.E2]}</td>
                <td>{data[member.id][ARMY_UNITS.E3]}</td>
                <td>{data[member.id][ARMY_UNITS.SIEGE_ENGINE]}</td>
                <td><span className={"white"}>{formatNumber(data[member.id].armyAttack)}</span><br />{formatNumber(data[member.id].armyDefence)}</td>
                <td><span className={"white"}>{formatNumber(data[member.id].wallAttack)}</span><br />{formatNumber(data[member.id].wallDefence)}</td>
                <td><span className={"white"}>{formatNumber(data[member.id].magicAttack)}</span><br />{formatNumber(data[member.id].magicDefence)}</td>
                <td><span className={"white"}>{formatNumber(data[member.id].thievesAttack)}</span><br />{formatNumber(data[member.id].thievesDefence)}</td>
              </tr>
            </>))
          }
          </tbody>
        </table>}
      </div>
      <span className="divider"/>
    </>
  )
}

export default AllianceOverview;
